import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const I18nContext = createContext({ locale: "es", t: translations.es, setLocale: () => {} });

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    if (typeof window === "undefined") return "es";
    const stored = localStorage.getItem("masterfit_locale");
    if (stored === "en" || stored === "es") return stored;
    const path = window.location.pathname;
    if (path.startsWith("/en")) return "en";
    return "es";
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    localStorage.setItem("masterfit_locale", locale);
    document.documentElement.lang = locale;
  }, [locale]);

  const t = translations[locale];
  return <I18nContext.Provider value={{ locale, setLocale, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
